/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    export class InfinityScroll implements angular.IDirective {
        restrict = 'A';
        scope = {
            isInitialMessagesPresent: "=",
            isNewMessage: '=',
            isNewMessagesList: '=',
            isRetakeElementHeight: '=isRetakeHeight',
            areMessagesEnded: '=',
            onScrollCallback: '&?',
        };

        private raw: HTMLElement;
        private initHeight: number;
        link = (scope: any, element: angular.IAugmentedJQuery) => {
            scope.init = () => {
                this.$timeout(() => {
                    this.raw.scrollTop = this.raw.scrollHeight;
                    this.initHeight = this.raw.scrollHeight;
                    scope.initListeners();
                }, 0);
            };
            scope.initListeners = () => {
                scope.$watch(() => scope.isNewMessagesList, (newVal: boolean, oldVal: boolean) => {                    
                    if (!newVal) return;
                    if (newVal === oldVal) {
                        // In the init state old and new values sre true
                        scope.isNewMessagesList = false;
                        return;
                    }

                    this.$timeout(() => {
                        this.raw.scrollTop = this.raw.scrollHeight - this.initHeight;
                        this.initHeight = this.raw.scrollHeight;
                        scope.isNewMessagesList = false;
                    }, 0);
                });

                scope.$watch(() => scope.isNewMessage, () => {
                    this.$timeout(() => {
                        element.animate({ scrollTop: this.raw.scrollHeight }, 'fast');
                        scope.isNewMessage = false;
                    }, 0);
                });

                scope.$watch(() => scope.isRetakeElementHeight, (newVal: boolean, oldVal: boolean) => {
                    if (!newVal) return;

                    this.initHeight = this.raw.scrollHeight;
                    scope.isRetakeElementHeight = false;

                    if (this.raw.scrollHeight - this.raw.scrollTop - this.raw.clientHeight < 1) this.$timeout(() => this.raw.scrollTop = this.raw.scrollHeight, 0);
                });

                element.bind('scroll', () => {
                    if (this.raw.scrollTop === 0) {
                        if (scope.areMessagesEnded) return;
                        if (scope.onScrollCallback) scope.onScrollCallback();
                    }
                });
            }

            this.raw = element[0];
            scope.isInitialMessagesPresent ? scope.init() : scope.initListeners();
        };

        constructor(
            protected $timeout: ng.ITimeoutService
        ) { }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => new InfinityScroll($timeout);
            directive.$inject = [
                '$timeout'
            ];

            return directive;
        }
    }

    angular.module('meevo.plugins.meevoMessenger')
        .directive('infinityScroll', InfinityScroll.factory());
}
